import { render, staticRenderFns } from "./answer-tags.vue?vue&type=template&id=4022d4cc&scoped=true"
import script from "./answer-tags.vue?vue&type=script&lang=js"
export * from "./answer-tags.vue?vue&type=script&lang=js"
import style0 from "./answer-tags.vue?vue&type=style&index=0&id=4022d4cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022d4cc",
  null
  
)

export default component.exports